import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { LogService } from 'src/app/shared/services/log.service';
import { CSForm } from '../models/cs-form.model';
import { FormAdmin } from '../../admin/edit-form/form-admin.model';
import { FormMember } from 'src/app/core/form-transaction/form-member.model';
import { CSFormReview } from '../models/cs-form-review';

@Injectable({ providedIn: 'root' })
export class CSFormService {
  apiHost: string = environment.apiHost;
  constructor(
    private http: HttpClient,
    private router: Router,
    private logService: LogService
  ) {}

  getForm(formId: number): Promise<CSForm> {
    let promise = new Promise<CSForm>((resolve, reject) => {
      return this.http
        .get<CSForm>(this.apiHost + '/Form/Get?FormId=' + formId)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Get Form Id=' + formId, msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  addForm(addForm: CSForm): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<any>(this.apiHost + '/Form/AddForm', addForm)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Add Form ' + addForm.name, msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  updateForm(updateForm: CSForm): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<any>(this.apiHost + '/Form/UpdateForm', updateForm)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog(
                'Admin: Add Form ' + updateForm.name,
                msg
              );
            reject(msg);
          }
        );
    });
    return promise;
  }

  deleteForm(formId: number): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<any>(this.apiHost + '/Form/DeleteForm?formId=' + formId, null)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog(
                'Admin: Delete Form ' + formId.toString(),
                msg
              );
            reject(msg);
          }
        );
    });
    return promise;
  }

  undeleteForm(formId: number): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<any>(this.apiHost + '/Form/UndeleteForm?formId=' + formId, null)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog(
                'Admin: Undelete Form ' + formId.toString(),
                msg
              );
            reject(msg);
          }
        );
    });
    return promise;
  }

  getAllForms(): Promise<CSForm[]> {
    let promise = new Promise<CSForm[]>((resolve, reject) => {
      return this.http
        .get<CSForm[]>(this.apiHost + '/Form/GetAllForms')
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Get All Forms', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  getFormsByUser(userId: string): Promise<CSForm[]> {
    let promise = new Promise<CSForm[]>((resolve, reject) => {
      return this.http
        .get<CSForm[]>(this.apiHost + '/Form/getFormsByUser?UserId=' + userId)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Get All Forms', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  reviewFormsByUser(userId: string): Promise<CSFormReview[]> {
    let promise = new Promise<CSFormReview[]>((resolve, reject) => {
      return this.http
        .get<CSFormReview[]>(
          this.apiHost + '/Form/reviewFormsByUser?UserId=' + userId
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Review Forms by User', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  getFormMember(userId: string, memberId: number): Promise<FormMember> {
    let promise = new Promise<FormMember>((resolve, reject) => {
      return this.http
        .get<FormMember>(
          this.apiHost +
            '/Member/GetFormMember?UserId=' +
            userId +
            '&MemberId=' +
            memberId
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Get Form Member', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  getFormMembers(userId: string, formId: number): Promise<FormMember[]> {
    let promise = new Promise<FormMember[]>((resolve, reject) => {
      return this.http
        .get<FormMember[]>(
          this.apiHost +
            '/Member/GetMemberByUserIdForm?UserId=' +
            userId +
            '&FormId=' +
            formId
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Get Form Members', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  getFormAdmins(): Promise<FormAdmin[]> {
    let promise = new Promise<FormAdmin[]>((resolve, reject) => {
      return this.http
        .get<FormAdmin[]>(this.apiHost + '/Form/GetFormAdmins')
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Get Form Admins', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }
}
